<template>
  <div class="app-header-root">
    <nav
      class="navbar navbar-expand-lg navbar-light bg-light p-0 dod-navbar-wrapper app-header-sticky"
    >
      <img
        style="
          cursor: pointer;
          padding: 0;
          height: 36px;
          width: 36px;
          object-fit: cover;
          overflow: unset;
        "
        class="navbar-brand"
        @click="moveToHomePage"
        src="../images/dod-image-logo.png"
      />
      <!-- <img
        v-else
        style="cursor: pointer"
        class="navbar-brand"
        @click="$router.push('/users')"
        src="../icons/logo.svg"
      /> -->
      <div
        v-if="!isMainApp && isLogged !== null"
        style="padding: 0; position: relative"
      >
        <SearchInput
          :customSize="205"
          @inputChange="(value) => handleSearchDodUser(value)"
          @onBlur="() => handleBlur()"
        />
        <div v-if="usersFound.length || noUsers" class="search-user-list">
          <span
            v-for="user in usersFound"
            :key="user.id"
            @click="() => redirectToUser(user)"
          >
            {{
              `${user.firstName} ${user.lastName} ${
                user.role === "CUSTOMER" ? "(Podopieczny)" : "(Opiekun)"
              }`
            }}
          </span>
          <span v-if="noUsers"> Brak użytkowników </span>
        </div>
      </div>
      <div class="searchUserPanel" v-else-if="isLogged != null">
        <!-- <form @submit.prevent="handleSearchUser"> -->
        <div class="inner-addon left-addon" style="max-width: 205px">
          <svg
            class="searchIcon"
            width="40"
            height="35"
            viewBox="0 0 30 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" clip-path="url(#clip0)">
              <path
                d="M26.8421 28.9995C26.5263 28.9995 26.2105 28.9995 25.8947 28.9995C25.5947 28.8 25.2474 28.6619 24.9947 28.4164C23.2579 26.7593 21.5368 25.0868 19.8158 23.4143C19.3263 22.954 19.0737 22.3249 19.3263 21.7418C19.6105 21.0974 19.3579 20.7598 18.9158 20.3915C18.6947 20.2074 18.4737 20.0233 18.3 19.7931C17.9211 19.3175 17.6053 19.3175 17.0684 19.655C11.8421 22.9693 4.76842 21.3582 1.56316 16.1566C0.742105 14.837 0.363158 13.3794 0 11.9064C0 11.1392 0 10.3873 0 9.62011C0.0473684 9.42064 0.126316 9.23652 0.157895 9.03704C0.852632 4.63334 4.32632 1.15027 8.92105 0.214293C13.2789 -0.675654 18.0316 1.24234 20.3842 4.95556C22.8316 8.83757 22.7368 12.7503 20.2895 16.6169C20.1474 16.8318 19.8316 17.0312 20.1474 17.3381C20.6368 17.8138 21.1105 18.2741 21.6 18.7497C21.7737 18.9185 21.9158 18.8418 22.1053 18.7804C23.0368 18.4122 23.7632 18.6884 24.4421 19.3482C25.9263 20.8212 27.4421 22.2788 28.9579 23.7212C29.3684 24.1201 29.7316 24.5344 30 25.0407C30 25.3476 30 25.6545 30 25.9614C29.1947 27.2042 28.1368 28.2169 26.8421 28.9995ZM11.0368 18.3815C15.4263 18.3968 18.9632 15.0058 18.9789 10.7556C18.9947 6.5053 15.4895 3.06826 11.1158 3.05292C6.69474 3.03757 3.15789 6.39789 3.12632 10.6482C3.09474 14.9445 6.6 18.3661 11.0368 18.3815Z"
                fill="#090741"
              />
              <path
                d="M15.3001 8.13255C15.2528 8.6389 15.0159 9.06853 14.4949 9.31404C13.9738 9.55954 13.437 9.55954 13.0107 9.20663C11.7001 8.10187 10.4528 8.13255 9.14223 9.22197C8.5896 9.68229 7.78434 9.52885 7.29486 9.0225C6.82118 8.5315 6.7896 7.7643 7.23171 7.21192C8.92118 5.06377 13.358 5.07911 15.0001 7.24261C15.1896 7.50345 15.3001 7.77964 15.3001 8.13255Z"
                fill="#090741"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="30" height="29" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <input
            type="text"
            placeholder="Szukaj"
            style="border-radius: 10px"
            class="form-control searchBlock"
            v-model="param"
          />
        </div>
      </div>
      <div>
        <custom-button
          v-if="!isMainApp"
          title="Dodaj +"
          size="small"
          custom-styles="margin-top: 0; border-radius: 20px; line-height: 20px;"
          @click="$router.push('/dod-add-customer-and-employee')"
        />
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon toggler-icon"></span>
      </button>
      <div
        v-if="isLogged != null"
        class="collapse navbar-collapse justify-content-center dod-navbar"
        id="navbarSupportedContent"
      >
        <router-link
          class="mr-3 mobile-bg"
          v-for="route in routes"
          :to="route.to"
          :key="route.to"
        >
          <div
            class="text-center headerBlock"
            :class="{ headerBorder: route.to === currentRoute }"
            v-if="route.roles.includes(userRole)"
          >
            <span
              class="counter"
              v-if="
                route.to === '/waitingusers' &&
                numberOfWaitingUsers &&
                numberOfWaitingUsers !== 0
              "
              >{{ numberOfWaitingUsers }}</span
            >
            <span
              class="counter"
              v-if="
                route.to === '/payouts-list' &&
                numberOfWaitingWithdraws &&
                numberOfWaitingWithdraws !== 0
              "
              >{{ numberOfWaitingWithdraws }}</span
            >
            <span
              class="counter"
              v-if="
                route.to === '/tasks' &&
                numberOfTodoTasks &&
                numberOfTodoTasks !== 0
              "
              >{{ numberOfTodoTasks }}</span
            >
            <span
              class="counter"
              v-if="
                route.to === '/chat' &&
                numberOfUnreadMessages &&
                numberOfUnreadMessages !== 0
              "
              >{{ numberOfUnreadMessages }}</span
            >
            <span
              class="counter"
              v-if="
                route.to === '/triedToLogIn' &&
                numberOfUsersWhoTriedToLogIn &&
                numberOfUsersWhoTriedToLogIn !== 0
              "
            >
              {{ numberOfUsersWhoTriedToLogIn }}
            </span>
            {{ route.name }}
          </div>
        </router-link>
        <div
          class="swtich mobile-bg"
          style="position: relative"
          v-if="(hasDodAccess && !dodAccessRevoked) || hasPodAccess"
        >
          <select
            class="panel-select"
            :value="activePanel"
            @change="selectPanel($event.target.value)"
          >
            <option value="MAIN_APP">Panel Aplikacji</option>
            <option v-if="hasDodAccess && !dodAccessRevoked" value="DOD">
              Panel DOD FSAPP
            </option>
            <option v-if="hasPodAccess" value="POD">Panel POD</option>
          </select>
          <span
            @click="showHideNotifications"
            v-if="
              !isMainApp &&
              dodAdminNotifications.data &&
              dodAdminNotifications.data.unreadNotifications
            "
            class="notifications-counter"
            >{{ dodAdminNotifications.data.unreadNotifications }}</span
          >
        </div>

        <div v-if="!isMainApp" class="mobile-bg" style="position: relative">
          <a style="cursor: pointer">
            <img
              @click="showHideNotifications"
              class="dod-icon"
              src="../icons/notifications.svg"
              alt=""
            />
          </a>
          <div class="notifications-list" v-if="notificationsShowed">
            <div
              @click="readNotificationAndRedirect(notification)"
              v-for="notification in dodAdminNotifications.data.notifications"
              :key="notification.id"
              class="notification-list-item"
              :class="{
                'notification-list-item-unread': !notification.isMarkedAsRead,
              }"
            >
              <img class="m-0" src="../icons/notifications-item.svg" alt="" />
              <div>
                <p
                  class="p-0 m-0"
                  v-html="formatTextMentions(notification.title)"
                ></p>
                <p class="m-0">"{{ notification.content }}"</p>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-bg">
          <router-link :to="isMainApp ? '/settings' : '/dod-panel-settings'">
            <img class="dod-icon" src="../icons/dodSettingIcon.svg" alt="" />
          </router-link>
        </div>

        <!-- <div v-if="isLogged != null && !DODSwitch">
          <router-link to="/">
            <i
              @click="logOut()"
              class="fas fa-sign-out-alt fa-1x pb-3 logoutButton"
              style="color: black"
            ></i>
          </router-link>
        </div> -->
        <div v-if="isLogged != null" class="mobile-bg">
          <router-link to="/">
            <img
              class="dod-icon"
              src="../icons/dodLogOutIcon.svg"
              alt=""
              @click="logOut()"
            />
          </router-link>
        </div>
      </div>
    </nav>
    <div
      class="modal fade p-0"
      id="changePasswordModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="changePasswordModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-s modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="changePasswordModal">Zmiana hasła</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body messagesBody">
            <form @submit.prevent="changePassword()">
              <label>Aktualne hasło</label>
              <input
                type="password"
                class="form-control"
                v-model="oldPassword"
                required
                placeholder="Aktualne hasło"
              />
              <label>Nowe hasło</label>
              <input
                type="password"
                class="form-control"
                minlength="6"
                v-model="newPassword"
                placeholder="Nowe hasło"
                required
              />
              <button
                class="form-control btn btn-outline-dark mr-3"
                style="margin-top: 10px"
                type="submit"
              >
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "../axios";
import SearchInput from "../components/SearchInput.vue";
import CustomButton from "../components/CustomButton.vue";
export default {
  components: {
    SearchInput,
    CustomButton,
  },
  data: function () {
    return {
      notificationsShowed: false,
      currentRoute: this.$route.path,
      oldPassword: "",
      newPassword: "",
      role: "",
      timeoutId: "",
      usersFound: [],
      noUsers: false,
      mainAppRoutes: [
        {
          to: "/chat",
          name: "Wiadomości",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/sms",
          name: "SMS",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/payments-list",
          name: "Płatności",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/payouts-list",
          name: "Wypłaty",
          roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        },
        {
          to: "/users",
          name: "Użytkownicy",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        // {
        //   to: "/user-commisions",
        //   name: "Prowizje użytkowników",
        //   roles: ["ADMIN", "ADMIN1", "ADMIN2"],
        // },
        {
          to: "/obiady",
          name: "Obiady",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3", "ADMIN4"],
        },
        {
          to: "/waitingusers",
          name: "Opiekunowie do zweryfikownia",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        // {
        //   to: "/unverified-photos",
        //   name: "Zdjęcia do zweryfikowania",
        // },
        {
          to: "/history",
          name: "Historia usług",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/tasks",
          name: "Zadania",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        // {
        //   to: "/logs",
        //   name: "Logi",
        //   roles: ["ADMIN", "ADMIN1"],
        // },
      ],
      DODRoutes: [
        {
          to: "/customers",
          name: "Dashboard",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/dod-sms-list",
          name: "SMS",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/dod-orders-list",
          name: "Zlecenia",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/dod-customers-list",
          name: "Podopieczni",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/dod-employees-list",
          name: "Opiekunowie",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/dod-reports-list",
          name: "Raporty",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
        {
          to: "/dod-settlements-list",
          name: "Rozliczenia",
          roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
        },
      ],
      roles: ["ADMIN", "ADMIN1", "ADMIN2", "ADMIN3"],
      param: null,
    };
  },
  created() {
    if (this.isLogged !== null) {
      this.$store.dispatch("fetchWaitingUsersCounter");
      this.$store.dispatch("fetchNumberOfUnreadMessagesCounter");
      this.$store.dispatch("fetchNumberOfTodoTasks");
      this.$store.dispatch("fetchNumberOfWaitingWithdraws");
      this.$store.dispatch("fetchDodAdminNotifications");
    }

    this.$store.dispatch("setUserToNull");
    this.role = Cookies.get("role");

    const storedPanel = window.sessionStorage.getItem("seniorapp_active_panel");
    const legacyDodView = window.sessionStorage.getItem("seniorapp_dod_view");
    let panelToRestore = storedPanel;
    if (!panelToRestore && Number(legacyDodView) === 1) {
      panelToRestore = "DOD";
    }
    if (panelToRestore && panelToRestore !== "MAIN_APP") {
      this.$store.dispatch("setActivePanel", panelToRestore);
      this.moveToMainPageDod();
    }
  },
  watch: {
    role: function () {
      this.setRole();
    },
    $route() {
      this.currentRoute = this.$route.path;
      if (this.$route.path.includes("settings")) {
        this.currentRoute = "/settings/services";
      }
    },
    param() {
      if (
        this.param &&
        (this.param.length === 6 ||
          this.param.length === 9 ||
          this.param.length === 36 ||
          this.param.length === 26 ||
          this.param.length === 13)
      ) {
        this.handleSearchUser();
      }
    },
    // Live DOD access was revoked (403 DOD_ACCESS_REVOKED): if the user is currently
    // in the DOD panel, drop them back to the main app panel (the DOD option also
    // disappears from the panel switcher). POD access is unaffected.
    dodAccessRevoked(val) {
      if (val && this.activePanel === "DOD") {
        this.$store.dispatch("setActivePanel", "MAIN_APP");
      }
    },
  },
  destroyed() {
    Cookies.set("role", null);
  },
  methods: {
    async readNotificationAndRedirect(notification) {
      await this.$store.dispatch("readDodAdminNotification", notification.id);

      // Powiadomienia rozliczeniowe: przekazanie do weryfikacji -> Rozliczenia,
      // cofnięcie do poprawy -> karta opiekuna (oba z miesiącem rozliczenia).
      if (notification.type === "SETTLEMENT_SUBMITTED") {
        this.$router.push({
          name: "DodSettlementsList",
          query: { month: notification.month, year: notification.year },
        });
        this.notificationsShowed = false;
        return;
      }
      if (notification.type === "SETTLEMENT_RETURNED") {
        this.$router.push({
          name: "DodEmployeeDetails",
          params: { id: notification.employeeId },
          query: { month: notification.month, year: notification.year },
        });
        this.notificationsShowed = false;
        return;
      }

      const routeObject = {
        name: notification.employeeId
          ? "DodEmployeeDetails"
          : "DodCustomerDetails",
        params: {
          id: notification.employeeId
            ? notification.employeeId
            : notification.customerId,
        },
        query: {
          toMessages: 1,
        },
      };

      if (
        this.$router.currentRoute.name === routeObject.name &&
        this.$router.currentRoute.params.id === routeObject.params.id
      ) {
        this.$router.replace(routeObject);
        setTimeout(() => {
          const messages = document.getElementById("dod-user-messages");
          if (messages) {
            messages.scrollIntoView({ behavior: "smooth" });
          }
        }, 1000);
      } else {
        this.$router.push(routeObject);
      }
      this.notificationsShowed = false;
    },
    formatTextMentions(text) {
      return text.replace(/@(\w+)/g, "<b>$1</b>");
    },
    showHideNotifications() {
      this.notificationsShowed = !this.notificationsShowed;
    },
    moveToHomePage() {
      if (this.isMainApp) {
        this.$router.push({ name: "users" });
      } else {
        this.$router.push({ name: "Customers" });
      }
    },
    moveToMainPageDod() {
      const isMainAppRoute = this.mainAppRoutes.find((route) =>
        route.to.includes(this.currentRoute)
      );
      if (isMainAppRoute) {
        this.$router.push({ name: "Customers" });
      }
    },
    moveToMainPageMainApp() {
      const isMainAppRoute = this.mainAppRoutes.find((route) =>
        route.to.includes(this.currentRoute)
      );
      if (!isMainAppRoute) {
        this.$router.push({ name: "users" });
      }
    },
    selectPanel(panel) {
      this.$store.dispatch("setActivePanel", panel);
      // Przy zmianie panelu zawsze wracamy na Dashboard danego panelu.
      if (panel === "MAIN_APP") {
        this.$router.push({ name: "users" }).catch(() => {});
      } else {
        this.$router.push({ name: "Customers" }).catch(() => {});
        // odswiez powiadomienia dla wybranego backendu (DOD/POD)
        this.$store.dispatch("fetchDodAdminNotifications");
      }
    },
    changePassword() {
      axios
        .post(`api/admin/changePassword`, {
          old_password: this.oldPassword,
          new_password: this.newPassword,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie zmieniono hasło",
            });
            (this.oldPassword = ""), (this.newPassword = "");
          }
        })
        .catch((err) => {
          console.log(err.response.data.error);
          if (err.response.data.error === "Wrong old password") {
            this.$notify({
              group: "error",
              text: "Podane nieprawidłowe hasło",
            });
          }
        });
    },
    setRole() {
      this.role = Cookies.get("role");
    },
    handleSearchUser() {
      this.$store.dispatch("fetchUserByPhoneOrUserId", {
        param: this.param,
      });
    },
    handleSearchDodUser(searchValue) {
      this.noUsers = false;
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(async () => {
        try {
          const response = await this.$store.dispatch("getDodUsers", {
            search: searchValue,
          });
          this.usersFound = response.data;
          if (!response.data.length) {
            this.noUsers = true;
          }
        } catch (error) {
          console.log(error);
        }
      }, 300);
    },
    redirectToUser(user) {
      this.$router.push({
        name:
          user.role === "CUSTOMER"
            ? "DodCustomerDetails"
            : "DodEmployeeDetails",
        params: {
          id: user.id,
        },
      });
      setTimeout(() => {
        this.resetSearchUserData();
      }, 500);
    },
    resetSearchUserData() {
      this.usersFound = [];
      this.timeoutId = "";
      this.noUsers = false;
    },
    handleBlur() {
      setTimeout(() => {
        this.resetSearchUserData();
      }, 1000);
    },
    logOut() {
      this.$store.dispatch("logout");
    },
  },

  computed: {
    dodAdminNotifications() {
      return this.$store.getters.getDodAdminNotifications;
    },
    admin() {
      return this.$store.getters.getLoggedAdmin;
    },
    dodAccessRevoked() {
      return this.$store.getters.getDodAccessRevoked;
    },

    hasDodAccess() {
      let loggedAdmin = JSON.parse(window.localStorage.getItem("loggedAdmin"));
      if (!loggedAdmin) {
        loggedAdmin = this.admin;
      }
      const hasUserAccessForDodRoutes = loggedAdmin?.hasDodAccess;
      return hasUserAccessForDodRoutes;
    },
    hasPodAccess() {
      let loggedAdmin = JSON.parse(window.localStorage.getItem("loggedAdmin"));
      if (!loggedAdmin) {
        loggedAdmin = this.admin;
      }
      return loggedAdmin?.hasPodAccess;
    },
    activePanel() {
      return this.$store.getters.getActivePanel;
    },
    isMainApp() {
      return this.activePanel === "MAIN_APP";
    },
    isLogged() {
      return this.$store.getters.getToken;
    },
    numberOfWaitingUsers() {
      return this.$store.getters.getWaitingUsersCounter;
    },
    numberOfUnreadMessages() {
      return this.$store.getters.getNumberOfUnreadMessages;
    },
    numberOfTodoTasks() {
      return this.$store.getters.getNumberOfTodoTasks;
    },
    userRole() {
      return this.$store.getters.getUserRole;
    },
    numberOfWaitingWithdraws() {
      return this.$store.getters.getNumberOfWaitingWithdraws;
    },
    numberOfUsersWhoTriedToLogIn() {
      return this.$store.getters.getNumberOfUsersWhoTriedToLogIn;
    },
    routes() {
      if (
        this.activePanel !== "MAIN_APP" &&
        (this.hasDodAccess || this.hasPodAccess)
      ) {
        return this.DODRoutes;
      } else {
        return this.mainAppRoutes;
      }
    },
  },
};
</script>
<style scoped>
/* The root is display: contents so <nav> is laid out as a direct child of #app:
   a sticky element only travels within its parent's box, which must span the
   whole page. Sticky + z-index sits on <nav>, not on the root, because it creates
   a stacking context capped at 1030 - the password modal below would then render
   under Bootstrap's body-level backdrop (1040) and be unclickable. */
.app-header-root {
  display: contents;
}
.app-header-sticky {
  position: sticky;
  top: 0;
  z-index: 1030;
}
.panel-select {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 4px 8px;
  background: #fff;
  font-size: 13px;
  cursor: pointer;
}
.counter,
.notifications-counter {
  position: absolute;
  top: 5px;
  right: 0px;
  border-radius: 100px;
  width: 15px;
  height: 15px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c40b0b;
  font-weight: bold;
}
.notifications-counter {
  color: white;
  background: #c40b0b;
  right: -17px;
  z-index: 5;
  font-weight: 400;
  cursor: pointer;
}
.searchButton {
  height: 20px !important;
}
.left-addon {
  display: flex;
  align-items: center;
}
.navbar {
  background-color: white !important;
  z-index: 999;
  margin-top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 6rem;
}
.navbar img {
  width: 147px;
  height: 70px;
  padding: 7px;
}
.logo-napis {
  color: black !important;
  text-decoration: none;
}
.underline-none {
  text-decoration: none;
}

.toggler-icon {
  font-size: 24px;
}
a {
  text-decoration: none;
}
.headerBlock {
  display: block;
  text-align: end;
  color: rgb(107, 107, 107);
  position: relative;
  height: 100%;
  font-family: "Poppins", sans-serif;
  font-weight: 400 !important;
}
.searchBlock {
  font-family: "Poppins", sans-serif;

  min-width: 120px;
}
.headerBorder {
  font-weight: 700 !important;
  color: #090741;
  border-bottom: 3px solid #f2b989;
}
.logoutButton {
  margin-top: 1em;
}

nav.dod-navbar-wrapper {
  background-color: #fdfdfd !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 0 32px !important;
}

nav .dod-navbar .mr-3 {
  margin-left: auto !important;
}

nav .dod-navbar .headerBlock {
  font-size: 14px;
  color: #090741;
}

nav .dod-navbar .headerBorder {
  color: #e2037e;
  border-bottom: unset;
}

nav .dod-navbar .swtich {
  margin-left: auto;
}

nav.dod-navbar-wrapper input.searchBlock {
  height: 40px;
  padding-left: 45px;
  color: #090741;
  border: 1px solid #090741;
  font-size: 14px;
}

div a .dod-icon {
  height: 24px;
  width: 24px;
  padding: 0;
}

.form-control {
  font-size: 11px;
}
.searchUserPanel {
  display: flex;
  align-items: center;
}
.searchUserPanel input {
  border-radius: 8px !important;
  color: #090741;
}
.searchUserInput {
  font-size: 13px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  width: 120px;
  border-radius: 50px;
}
.searchUserButton {
  font-size: 13px;
  width: 120px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

.toggle {
  margin-right: 10px;
}
.toggle i {
  font-size: 18px;
  cursor: pointer;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
.headerBlock {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
#navbarSupportedContent,
#navbarSupportedContent a {
  height: 100%;
  padding: 0;
}

.search-user-list {
  position: absolute;
  width: calc(100% - 20px);
  left: 10px;
  background-color: white;
  border-radius: 5px;
  z-index: 999;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  max-height: 450px;
  overflow-y: auto;
  padding: 0 10px;
}

.notifications-list {
  position: absolute;
  background: red;
  max-height: 600px;
  width: 500px;
  top: 35px;
  right: 10px;

  background: #ffffff;
  border-radius: 5px;
  margin: 0;
  padding: 0rem;
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.75);
  z-index: 100000;
  overflow-y: auto;
}
.notification-list-item {
  min-height: 60px;
  display: flex;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid #c1c1c1;
  background: none;
}
.notification-list-item:hover {
  background: #eeeeee;
  /* background: rgba(226, 3, 126, 0.1); */

  cursor: pointer;
}
.notification-list-item img {
  width: 50px;
}
.notification-list-item-unread {
  background: rgba(226, 3, 126, 0.07);
}

.search-user-list span {
  cursor: pointer;
  border-bottom: 1px solid #c1c1c1;
  min-height: 40px;
  display: flex;
  align-items: center;
  width: 100%;
}

@media only screen and (max-width: 1450px) {
  .headerBlock {
    font-size: 12px;
  }
}

@media only screen and (max-width: 1230px) {
  .headerBlock,
  .counter {
    font-size: 9px;
  }
  .navbar-brand {
    display: none;
  }
}

@media only screen and (max-width: 991px) {
  .mobile-bg {
    display: block;
    background-color: #fdfdfd;
    border-color: #090741;
    border-left-width: 1px;
    border-right-width: 1px;
    border-right-style: solid;
    border-left-style: solid;
    box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.5);
    width: 100%;
    padding-left: 10px !important;
  }
  .mobile-bg:nth-child(1) {
    border-top-style: solid;
    border-top-width: 1px;
  }
  .mobile-bg:nth-last-child(1) {
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }
}
</style>
